/* JC search results page (sections/jc-search-page.liquid).
   Filters/sort reload the results area via the Section Rendering API (?section_id=) and keep the
   URL in sync with history.replaceState. "Load more" appends the next page. Product-type chips
   filter client side when the store has no product type filter. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.jcSpReady) return;
    root.dataset.jcSpReady = '1';
    var sectionId = root.getAttribute('data-section-id');
    var busy = false;

    function body() { return root.querySelector('[data-jc-sp-body]'); }

    function sectionUrl(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }

    function cleanUrl(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete('section_id');
      return u.pathname + (u.search ? u.search : '');
    }

    function fetchSection(url) {
      return fetch(sectionUrl(url), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          return new DOMParser().parseFromString(html, 'text/html');
        });
    }

    /* Reload the results area for a new URL (filters, sort, chips, clear) */
    function reload(url) {
      var b = body();
      if (!b || busy) return;
      busy = true;
      b.classList.add('is-loading');
      b.setAttribute('aria-busy', 'true');
      fetchSection(url)
        .then(function (doc) {
          var fresh = doc.querySelector('[data-jc-sp-body]');
          if (!fresh) throw new Error('no body');
          b.innerHTML = fresh.innerHTML;
          try { window.history.replaceState({}, '', cleanUrl(url)); } catch (e) { /* ignore */ }
        })
        .catch(function () { window.location.href = cleanUrl(url); })
        .then(function () {
          busy = false;
          var nb = body();
          if (nb) { nb.classList.remove('is-loading'); nb.removeAttribute('aria-busy'); }
        });
    }

    function currentUrl() { return new URL(window.location.href); }

    function urlFromForm(form) {
      var u = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
      var fd = new FormData(form);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) {
        if (typeof v === 'string' && v.trim() === '') return;
        params.append(k, v);
      });
      if (!params.has('sort_by')) {
        var s = currentUrl().searchParams.get('sort_by');
        if (s) params.set('sort_by', s);
      }
      if (params.get('sort_by') === 'relevance') params.delete('sort_by');
      params.delete('page');
      u.search = params.toString();
      return u.toString();
    }

    function closePops(except) {
      root.querySelectorAll('[data-jc-col-pill-btn][aria-expanded="true"]').forEach(function (btn) {
        if (btn === except) return;
        btn.setAttribute('aria-expanded', 'false');
        var pop = document.getElementById(btn.getAttribute('aria-controls'));
        if (pop) pop.hidden = true;
      });
    }

    function drawer() { return root.querySelector('[data-jc-sp-drawer]'); }

    function openDrawer() {
      var d = drawer();
      if (!d) return;
      if (typeof d.showModal === 'function') {
        d.showModal();
        requestAnimationFrame(function () { d.classList.add('is-in'); });
      } else {
        d.setAttribute('open', '');
        d.classList.add('is-in');
      }
    }

    function closeDrawer() {
      var d = drawer();
      if (!d || !d.open) return;
      d.classList.remove('is-in');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(function () { if (d.open) d.close(); }, reduce ? 0 : 300);
    }

    function filterType(type) {
      var grid = root.querySelector('[data-jc-sp-grid]');
      if (!grid) return;
      grid.querySelectorAll('.jc-sp__item').forEach(function (li) {
        li.hidden = !!type && li.getAttribute('data-type') !== type;
      });
      root.querySelectorAll('[data-jc-sp-type]').forEach(function (c) {
        var on = c.getAttribute('data-jc-sp-type') === type;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function loadMore(link) {
      var more = root.querySelector('[data-jc-sp-more]');
      var grid = root.querySelector('[data-jc-sp-grid]');
      if (!more || !grid || busy) return;
      busy = true;
      link.setAttribute('aria-busy', 'true');
      var url = link.href;
      fetchSection(url)
        .then(function (doc) {
          var items = doc.querySelectorAll('[data-jc-sp-grid] > .jc-sp__item');
          var activeChip = root.querySelector('[data-jc-sp-type].is-active');
          var type = activeChip ? activeChip.getAttribute('data-jc-sp-type') : '';
          var first = null;
          items.forEach(function (li) {
            var node = document.importNode(li, true);
            node.classList.add('is-new');
            if (type && node.getAttribute('data-type') !== type) node.hidden = true;
            grid.appendChild(node);
            if (!first) first = node;
          });
          var freshMore = doc.querySelector('[data-jc-sp-more]');
          if (freshMore) {
            var shown = (parseInt(more.dataset.shown, 10) || 0) + items.length;
            var total = parseInt(freshMore.dataset.total, 10) || shown;
            if (shown > total) shown = total;
            more.dataset.shown = String(shown);
            var showing = more.querySelector('[data-jc-sp-showing]');
            if (showing) showing.textContent = 'Showing ' + shown.toLocaleString('en-US') + ' of ' + total.toLocaleString('en-US');
            var fill = more.querySelector('[data-jc-sp-fill]');
            if (fill) fill.style.transform = 'scaleX(' + (total ? shown / total : 1) + ')';
            var nextLink = freshMore.querySelector('[data-jc-sp-loadmore]');
            if (nextLink) {
              link.href = nextLink.getAttribute('href');
              link.textContent = nextLink.textContent;
              link.removeAttribute('aria-busy');
            } else {
              link.remove();
            }
          }
          try { window.history.replaceState({}, '', cleanUrl(url)); } catch (e) { /* ignore */ }
          if (first) {
            var a = first.querySelector('a[href]');
            if (a) a.focus({ preventScroll: true });
          }
        })
        .catch(function () { window.location.href = url; })
        .then(function () { busy = false; });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var clear = t.closest('[data-jc-sp-clear]');
      if (clear) {
        var q = root.querySelector('[data-jc-sp-q]');
        if (q) { q.value = ''; q.focus(); }
        clear.hidden = true;
        return;
      }
      var pillBtn = t.closest('[data-jc-col-pill-btn]');
      if (pillBtn) {
        var open = pillBtn.getAttribute('aria-expanded') === 'true';
        closePops(pillBtn);
        pillBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var pop = document.getElementById(pillBtn.getAttribute('aria-controls'));
        if (pop) {
          pop.hidden = open;
          if (!open) {
            var f = pop.querySelector('input:not([disabled]), button');
            if (f) f.focus({ preventScroll: true });
          }
        }
        return;
      }
      var clearGroup = t.closest('[data-jc-col-clear-group]');
      if (clearGroup) {
        var grp = clearGroup.closest('.jc-col-pop');
        if (grp) {
          grp.querySelectorAll('input').forEach(function (i) {
            if (i.type === 'checkbox') i.checked = false; else i.value = '';
          });
          var form = clearGroup.closest('form');
          if (form) reload(urlFromForm(form));
        }
        return;
      }
      var typeChip = t.closest('[data-jc-sp-type]');
      if (typeChip) { filterType(typeChip.getAttribute('data-jc-sp-type')); return; }
      if (t.closest('[data-jc-sp-open]')) { openDrawer(); return; }
      if (t.closest('[data-jc-sp-close]')) { closeDrawer(); return; }
      var d = drawer();
      if (d && t === d) { closeDrawer(); return; } /* backdrop click */
      var lm = t.closest('[data-jc-sp-loadmore]');
      if (lm) { e.preventDefault(); loadMore(lm); return; }
      var link = t.closest('[data-jc-sp-link]');
      if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        if (d && d.open) { d.classList.remove('is-in'); d.close(); }
        reload(link.href);
      }
    });

    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-jc-sp-form]');
      if (!form) return;
      e.preventDefault();
      var d = drawer();
      if (d && d.open) { d.classList.remove('is-in'); d.close(); }
      closePops();
      reload(urlFromForm(form));
    });

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-jc-sp-sort]');
      if (!sel) return;
      var u = currentUrl();
      if (sel.value && sel.value !== 'relevance') u.searchParams.set('sort_by', sel.value);
      else u.searchParams.delete('sort_by');
      u.searchParams.delete('page');
      if (!u.searchParams.has('type')) u.searchParams.set('type', 'product');
      reload(u.toString());
    });

    root.addEventListener('input', function (e) {
      if (!e.target.matches('[data-jc-sp-q]')) return;
      var c = root.querySelector('[data-jc-sp-clear]');
      if (c) c.hidden = e.target.value === '';
    });

    root.addEventListener('cancel', function (e) {
      if (e.target.matches && e.target.matches('[data-jc-sp-drawer]')) { e.preventDefault(); closeDrawer(); }
    }, true);

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.jc-col-pill')) closePops();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openBtn = root.querySelector('[data-jc-col-pill-btn][aria-expanded="true"]');
      if (openBtn) { closePops(); openBtn.focus(); }
    });
  }

  function boot() { document.querySelectorAll('[data-jc-sp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
